import * as React from 'react'
import DangerouslySetInnerHtml from '../dangerouslySetInnerHtml'
import SafeInnerHtml from '../safeInnerHtml'

const SeoHeadings = ({
  TagName = 'p',
  heading,
  subHeading,
  finePrint,
  styles = {}
}: {
  TagName: string
  heading: string
  subHeading: string
  finePrint?: string
  styles: any
}) => {
  return (
    <div data-test-selector="SeoHeadings">
      <TagName
        className={styles.seoHeading}
        dangerouslySetInnerHTML={{ __html: heading }}
      />
      {subHeading && (
        <h2 className={styles.seoSubHeading}>
          <DangerouslySetInnerHtml>{subHeading}</DangerouslySetInnerHtml>
        </h2>
      )}
      {finePrint && (
        <small className={styles.seoFinePrint}>
          <SafeInnerHtml html={finePrint} />
        </small>
      )}
    </div>
  )
}

export default SeoHeadings



// WEBPACK FOOTER //
// ./client/components/seoHeadings/seoHeadings.tsx